const items = {
  "flashes.success": "success",
  "message.irrevocable": "irrevocable",
  "message.delete.confirm": "confirm delete",
  "message.auth.guest.alert": "guest read public resource only.",
  "message.channel.empty.alert": "channel is empty,only original text",
  "message.time": "{time} seconds",
  "message.result": "{count} results",
  "message.send.reset.email":
    "The system will send a link containing the information necessary to reset your password to your registered email address. Please enter your registered email address and ensure that the email is capable of receiving messages.",
  "message.send.reset.email.successful":
    "The password for reset email has been sent to your inbox.",
  "message.password.reset.successful": "password reset successful",
  "message.password.reset": "please set new password",
  "message.get.token.fail": "get token fail",
  "message.confirm-password.validate.fail": "password validate fail",
  "message.delete.success": "delete record {count}",
  "message.task.status.change": "Do you want change statue to {status}?",
};

export default items;
